export default {
    API_ORIGIN: null,
    PATH: null,
    API_URL: null,
    passwordRecoveryUrl: "",
    registrationUrl: "",
    orderListUrl: "",
    mwSendReservationMails: "",
    orderInfo: "",
    popover: {
        x: -1000,
        y: -1000,
        show: false,
        text: null,
        height: null,
        nowrap: false,
        preType: false,
        down: null,
    },
    tourSettings: null,
    allCurrency: null,
    tourCurrency: null,
    tourLocalize: null,
    tourLocalizeList: null,
    alertShow: false,
    quotaReady: true,
    coursesReady: true,
    serverOff: false,
    serverInit: true,
    filtersAvailable: true,
    filtersInit: true,
    licenseStatus: true,
    closeAlert: null,
    rate: null,
    nationalRate: null,
    busketCurrencyReady: true,
    localizeError: false,
    quotaServices: [],
    currencyRates: [],
    isDarkTheme: false,
}
